import * as React from 'react';
import { connect } from 'react-redux';
import { CategoriesService } from '../../services/categoriesService';
import IBookmarkState from './interfaces/bookmarkState';
import IEditModal from './interfaces/editModal';
import { actionCreators } from './redux/actions';
import { createPortal } from 'react-dom';
import { BookmarkService } from '../../services/bookmarkService';

class EditModal extends React.Component<IEditModal, null> {
    render() {
        let name;
        if (this.props.categories && this.props.selectedCategoryId && this.props.display) {
            name = this.props.categories.filter(c => c.categoryId === this.props.selectedCategoryId).pop().categoryName;
        }
        const buttonIsDisabled = !this.props.editedCategoryName;

        return (
            createPortal(
                <React.Fragment>
                    {this.props.display && this.props.selectedCategoryId
                        ? <div className="bookmarks__modal" onClick={(event) => event.stopPropagation()}>
                            <div className="bookmarks__modal-backdrop"></div>

                            <div className="bookmarks__modal-innercontainer">
                                <button onClick={(event) => this.props.toggleEditModal(event)} className="modal__close">Stäng</button>
                                <div className="modal__content">
                                    <h2 className="modal__title">Redigera kategori</h2>
                                    <div className="share-content">
                                        <div className="form-field">
                                            <input type="text" id="categoryName" className="form-field__textbox" defaultValue={name || 'Ange namn för kategori'} autoComplete="off" autoFocus onChange={(event) => this.props.setEditedCategoryName(event)} />
                                            <label className="form-field__label" htmlFor="categoryName">Namn på kategori</label>
                                        </div>
                                        <p className="bookmarks__paragraph">
                                            Om du väljer att ta bort denna kategori så kommer de favoriter som är kopplade flyttas till <strong>Okategoriserat</strong>. Inga favoriter kommer att tas bort.
                                        </p>
                                    </div>
                                    <div className="button-group modal__button-group">
                                        <button className="genericBtn alternate" onClick={(event) => { this.props.deleteEditedCategory && this.props.deleteEditedCategory(event, this.props.selectedCategoryId, this.props.categories)}}>Ta bort kategori</button>
                                        <button className={`genericBtn primary ${buttonIsDisabled ? 'modal__button--disabled' : ''}`} onClick={(event) => { this.props.saveEditedCategoryName && this.props.saveEditedCategoryName(event, this.props.editedCategoryName, this.props.selectedCategoryId, this.props.categories)}}>Spara ändring</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null
                    }
                </React.Fragment>,
                document.body
            )
        );
    }
}

const mapDispatchToProps = (dispatch, ownProps): IEditModal => {
    const bookmarkService = new BookmarkService();
    const categoriesService = new CategoriesService();
    return {
        ...ownProps,
        toggleEditModal: (event) => {
            event.preventDefault();
            dispatch(actionCreators.toggleEditModal());
            dispatch(actionCreators.setEditedCategoryName(''));
        },
        saveEditedCategoryName: (event, editedCategoryName: string, categoryId: string, dataset: any[]) => {
            event.preventDefault();
            if (editedCategoryName) {
                const category = dataset.filter(c => c.categoryId === categoryId).pop();
                category.name = editedCategoryName;
                categoriesService.editCategory(category, (response) => {
                    if (response) {
                        dispatch(actionCreators.toggleEditModal())
                        dispatch(actionCreators.setEditedCategoryName(''))
                        if (response && response.id && response.name) {
                            categoriesService.getCategories((success) => {
                                if (success) {
                                    dispatch(actionCreators.populateCategories(success));
                                }
                            }, (fail) => {
                                return
                            })
                            dispatch(actionCreators.setToastBarType('success'));
                            dispatch(actionCreators.setToastBarMessage('Ändring sparades'));
                            dispatch(actionCreators.toggleToastBar());
                        }
                    }
                }, (error) => {
                    dispatch(actionCreators.setToastBarType('warn'));
                    dispatch(actionCreators.setToastBarMessage('Kunde inte ändra kategori'));
                    dispatch(actionCreators.toggleToastBar());
                });
            }
        },
        deleteEditedCategory: (event, categoryId: string, dataset: any[]) => {
            event.preventDefault();
            const category = dataset.filter(c => c.categoryId === categoryId).pop();
            categoriesService.deleteCategory(category, (response) => {
                // the api service doesn't return the actual response object, success is an empty string for DELETE.
                if (response === '') {
                    dispatch(actionCreators.toggleEditModal())
                    dispatch(actionCreators.setEditedCategoryName(''))
                    categoriesService.getCategories((success) => {
                        if (success) {
                            dispatch(actionCreators.populateCategories(success));
                        }
                    }, (fail) => {
                        return
                    });

                    bookmarkService.getBookmarks((data) => {
                        if (data && data.length > 0) {
                            dispatch(actionCreators.populateBookmarks(data));
                        }
                    }, (error) => { console.error(error) });
                }
            }, (error) => {
                dispatch(actionCreators.setToastBarType('warn'));
                dispatch(actionCreators.setToastBarMessage('Något gick fel. Kunde inte ta bort kategori'));
                dispatch(actionCreators.toggleToastBar());
                console.error(error);
            });
        },
        setEditedCategoryName: (event) => {
            event.preventDefault();
            dispatch(actionCreators.setEditedCategoryName(event.target.value))
        }
    };
}

const mapStateToProps = (state: IBookmarkState): IEditModal => {
    return { display: state.displayEditModal, editedCategoryName: state.editedCategoryName, selectedCategoryId: state.selectedCategoryId, categories: state.categories };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditModal);